import { Box } from '@material-ui/core';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { Typography } from 'components/Typography';

import { Tool } from './icons';
import { useStyles } from './styles';

export const ErrorPage: FC = () => {
  const classes = useStyles();
  return (
    <Box display="flex" justifyContent="center" alignItems="center" mt={1}>
      <div className={classes.container}>
        <Tool />
        <Typography variant="headingMD">
          <FormattedMessage
            defaultMessage="We can't find this page"
            description="Message title for 404 error page"
          />
        </Typography>
        <Typography>
          <FormattedMessage
            defaultMessage="The page you are looking for no longer exists. Check that you typed the
          address correctly, or return to your previous page."
            description="Message body for 404 error page"
          />
        </Typography>
      </div>
    </Box>
  );
};
